<div class="position-relative">
    <lib-input
        #autocompleteInput
        (onBlurEvent)="onBlur()"
        (onFocusEvent)="onFocus()"
        (onInputEvent)="onInput($event)"
        [debounce]="300"
        [errorText]="errorText"
        [ionItemWrap]="false"
        [label]="label"
        [ngClass]="{ 'ion-no-margin': noVSpacing }"
        [placeholder]="placeholder"
        [disabled]="disabled">
        @if (showLocationIcon) {
            <lib-svg-icon iconName="location-outline" slot="start"></lib-svg-icon>
        }
    </lib-input>

    <div
        [hidden]="!displayDropdown"
        [ngClass]="{
            'ion-padding-horizontal': ionItemWrap,
            'input-address-dropdown': !inlineDropdown,
            'border ion-margin-bottom':
                isLoading ||
                autocompleteSuggestionsList.length ||
                (inputValue && !autocompleteSuggestionsList.length && !isLoading && !chosenAddress)
        }"
        class="input-address-wrapper">
        <p *ngIf="isLoading" class="ion-padding-horizontal">Loading...</p>

        <ion-list [hidden]="!autocompleteSuggestionsList || autocompleteSuggestionsList.length === 0">
            <ion-item
                (click)="onAddressSelect(address)"
                *ngFor="let address of autocompleteSuggestionsList"
                [button]="true">
                <p class="text-dark">{{ address.formattedAddress.toString() }}</p>
            </ion-item>
            <ion-item *ngIf="autocompleteSuggestionsList.length" class="ion-text-right" lines="none">
                <div class="google-logo-wrapper">
                    <img [src]="googleLogoUrl" alt="Suggestions from Google" />
                </div>
            </ion-item>
        </ion-list>
        <div
            *ngIf="inputValue && !autocompleteSuggestionsList.length && !isLoading && !chosenAddress"
            class="ion-padding input-address-dropdown--no-address">
            <p class="ion-no-margin">No locations found</p>
        </div>
    </div>

    <lib-input
        #additionalInfoInput
        (onInputEvent)="onAdditionalInfoInput($event)"
        [hidden]="!displayAdditionalInfoInput"
        [initialValue]="additionalInfoInitialValue"
        [ionItemWrap]="ionItemWrap"
        [label]="additionalInfoLabel"
        [ngClass]="{ 'ion-no-margin': noVSpacing }"
        [placeholder]="additionalInfoPlaceholder"
        [disabled]="disabled" />
</div>
